import { createModel } from "@rematch/core";
import {
  ProductType,
  SupplyType,
  SupplyTypesMappedToProductFamiliesState,
} from "src/types";

import { RootModel } from ".";

const initialState: SupplyTypesMappedToProductFamiliesState = {
  [ProductType.ELECTRICITY]: {
    [SupplyType.GV]: [],
    [SupplyType.SV]: [],
  },
  [ProductType.GAS]: {
    [SupplyType.GV]: [],
    [SupplyType.SV]: [],
  },
};

export const supplyTypesMappedToProductFamilies = createModel<RootModel>()({
  state: initialState as SupplyTypesMappedToProductFamiliesState,
  reducers: {
    fetchSuccess(
      state,
      payload: Partial<SupplyTypesMappedToProductFamiliesState>
    ) {
      return {
        ...state,
        ...payload,
      };
    },
    fetchFail(state) {
      return { ...state };
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/supplyTypesMappedToProductFamilies.ts